import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const productboard = defineConnector({
  identifier: "productboard",
  name: "Productboard",
  tagLine: "Product management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.productboard\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get a developer token",
      items: [
        {
          kind: "markdown",
          content:
            "Productboard admins can retrieve a developer token from the integrations page in workspace settings. The public Notes API uses Bearer authentication.",
        },
      ],
    },
    {
      title: "Enter your Productboard token",
      items: [
        {
          kind: "input",
          label: "Developer token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.productboard.com/notes",
  },
});
